import React, { useEffect, useState } from "react";
import { api } from "@/contexts/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const sel = "h-9 w-full rounded-sm border border-[#0B132B]/15 bg-white px-2 text-sm";

export const DealerOwnershipDialog = ({ dealer, open, onClose, onSaved }) => {
  const [opts, setOpts] = useState(null);
  const [agencyId, setAgencyId] = useState("");
  const [userId, setUserId] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    setAgencyId(dealer.agency_id || ""); setUserId(dealer.user_id || "");
    api.get("/dealer-tools/import-options").then(({ data }) => setOpts(data)).catch(() => toast.error("Could not load agencies"));
  }, [open, dealer.id, dealer.agency_id, dealer.user_id]);

  const agents = (opts?.agents || []).filter((a) => !agencyId || !a.agency_id || a.agency_id === agencyId);
  const save = async () => {
    setBusy(true);
    try {
      const body = {};
      if (agencyId && agencyId !== dealer.agency_id) body.agency_id = agencyId;
      if (userId && userId !== dealer.user_id) body.user_id = userId;
      if (!Object.keys(body).length) { onClose(); return; }
      await api.put(`/dealers/${dealer.id}`, body);
      toast.success("Dealer reassigned"); onSaved?.(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Reassign failed"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-sm max-w-md" data-testid="reassign-dialog">
        <DialogHeader><DialogTitle>Reassign {dealer.dealer_name}</DialogTitle></DialogHeader>
        <p className="text-xs text-[#6C757D]">Move this dealer to a different agency and/or Agent of Record. The pipeline record follows the new owner.</p>
        <div className="space-y-3">
          <div><Label className="text-[10px] uppercase tracking-[0.14em] font-bold text-[#6C757D]">Agency</Label>
            <select value={agencyId} onChange={(e) => { setAgencyId(e.target.value); setUserId(""); }} className={sel} data-testid="reassign-agency">
              <option value="">— select agency —</option>{(opts?.agencies || []).map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}</select></div>
          <div><Label className="text-[10px] uppercase tracking-[0.14em] font-bold text-[#6C757D]">Agent of Record</Label>
            <select value={userId} onChange={(e) => setUserId(e.target.value)} className={sel} data-testid="reassign-agent">
              <option value="">— keep current —</option>{agents.map((a) => <option key={a.id} value={a.id}>{a.name}{a.agency ? ` · ${a.agency}` : ""}</option>)}</select></div>
        </div>
        <div className="flex justify-end gap-2 mt-2">
          <Button variant="outline" onClick={onClose} className="h-9 rounded-sm">Cancel</Button>
          <Button onClick={save} disabled={busy || !opts} className="h-9 rounded-sm bg-[#0B132B] text-white" data-testid="reassign-save">{busy ? "Saving…" : "Reassign"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
